import emailjs from '@emailjs/browser';

// ─── EmailJS Configuration ────────────────────────────────────────────────────
// 1. Go to https://www.emailjs.com and sign up for a free account
// 2. Add an Email Service (Gmail/Outlook) → copy the Service ID
// 3. Create an Email Template → copy the Template ID
// 4. Go to Account → API Keys → copy the Public Key
// Replace the values below with your actual credentials
// ─────────────────────────────────────────────────────────────────────────────
export const EMAILJS_SERVICE_ID  = 'YOUR_SERVICE_ID';
export const EMAILJS_TEMPLATE_ID = 'YOUR_TEMPLATE_ID';
export const EMAILJS_PUBLIC_KEY  = 'YOUR_PUBLIC_KEY';

export const sendEmail = (templateParams) => {
  return emailjs.send(
    EMAILJS_SERVICE_ID,
    EMAILJS_TEMPLATE_ID,
    { ...templateParams, to_email: 'support@egbsystems.com' },
    EMAILJS_PUBLIC_KEY
  );
};
